export default {"src":"/_next/static/media/rank3.b37fa5ea.svg","height":13,"width":9,"blurWidth":0,"blurHeight":0};